import { render, staticRenderFns } from "./SalesAccountTable.vue?vue&type=template&id=5839e192&"
import script from "./SalesAccountTable.vue?vue&type=script&lang=js&"
export * from "./SalesAccountTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports